import {Mensaje} from "../..";
import { ApiService } from "../../../shared";

export interface MensajeServiceInterface extends ApiService<Mensaje>{
}
